angular.module('satv.track')
.factory('KeywordType', ['config', '$resource', function(config, $resource) {
    return $resource(config.apiUri + '/keywordtypes', {
        lang: config.lang
    });
}]);


// WEBPACK FOOTER //
// ./vendor/sonyatv/smfcoreclientbundle/Resources/js/angular/services/KeywordType.js